import Icon, { ICON_HEART, ICON_CHAT_BUBBLE_LINE, ICON_HOME, ICON_WALLET_LINE } from '~/components/icon/index.js';
import {
	ROUTE_WE_SPIN_GAME_ROOM_INFO,
	ROUTE_WE_SPIN_GAME_ROOM_CHAT,
	ROUTE_WE_SPIN_GAME_ROOM_TIP,
	ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST
} from '../constants/we-spin-route-constants.js';
import {
	WE_SPIN_GAME_ROOM_TAB_ITEM_CHAT,
	WE_SPIN_GAME_ROOM_TAB_ITEM_BALANCE,
	WE_SPIN_GAME_ROOM_TAB_ITEM_TIP,
	WE_SPIN_GAME_ROOM_TAB_ITEM_EVENT_LIST
} from '../constants/we-spin-text-keys.js';
import WeSpinGameRoomTip from './we-spin-game-room-tip.js';
import WeSpinGameRoomChat from './we-spin-game-room-chat.js';
import WeSpinGameRoomEventList from './we-spin-game-room-event-list.js';
import WeSpinGameRoomInfo from './we-spin-game-room-info.js';

const WE_SPIN_GAME_ROOM_TAB_ITEMS = [
	{
		icon: <Icon type={ICON_HOME} />,
		labelKey: WE_SPIN_GAME_ROOM_TAB_ITEM_EVENT_LIST,
		link: ROUTE_WE_SPIN_GAME_ROOM_EVENT_LIST,
		Component: WeSpinGameRoomEventList
	},
	{
		icon: <Icon type={ICON_CHAT_BUBBLE_LINE} />,
		labelKey: WE_SPIN_GAME_ROOM_TAB_ITEM_CHAT,
		link: ROUTE_WE_SPIN_GAME_ROOM_CHAT,
		Component: WeSpinGameRoomChat
	},
	{
		icon: <Icon type={ICON_WALLET_LINE} />,
		labelKey: WE_SPIN_GAME_ROOM_TAB_ITEM_BALANCE,
		link: ROUTE_WE_SPIN_GAME_ROOM_INFO,
		Component: WeSpinGameRoomInfo
	},
	{
		icon: <Icon type={ICON_HEART} />,
		labelKey: WE_SPIN_GAME_ROOM_TAB_ITEM_TIP,
		link: ROUTE_WE_SPIN_GAME_ROOM_TIP,
		Component: WeSpinGameRoomTip
	}
];

export default WE_SPIN_GAME_ROOM_TAB_ITEMS;
